module.exports = __webpack_public_path__ + "img/bg_vip_logo.775b3e4e.png";